import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {FullTable} from "components";
import {legsActions} from "store";
import {
    ACTION_TYPE_GET_LEGS, ACTION_TYPE_GET_LEGS_SUCCESS,
    emptyStatePatientTrips,
    patientTripsBody,
    patientTripsHead
} from "../constants";
import {limit} from "utils";

export const PatientTrips = ({currentId, filters}) => {
    const [sendParams, setSendParams] = useState({
        skip: 0,
        limit: limit,
    });
    const legsList = useSelector((state) => state.legs?.legsList);
    const dispatch = useDispatch();


    const getLegInfo = (noLoad) => {
        const params = {
            ...sendParams,
            ...filters,
            patient: currentId,
        };

        if (params?.page) delete params.page;

        dispatch(legsActions.getLegs(params, noLoad))
    }

    useEffect(() => {
        getLegInfo();

        return () => {
            dispatch({
                type: ACTION_TYPE_GET_LEGS_SUCCESS,
                payload: null,
            })
        }
    }, [sendParams, filters])


    return (
        <div>
            <FullTable
                head={patientTripsHead}
                body={patientTripsBody}
                list={legsList?.legs || []}
                listCount={legsList?.count}
                loadingType={ACTION_TYPE_GET_LEGS}
                emptyState={emptyStatePatientTrips}
                containerStyles={{height: "53vh", margin: 0}}
                getParams={setSendParams}
                currentParams={{page: filters?.page}}
            />
        </div>
    );
};

